import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbNavigation = ({ customBreadcrumbs = null }) => {
  const location = useLocation();

  const routeLabels = {
    '/': 'Home',
    '/login': 'Inloggen',
    '/super-admin-dashboard': 'Super Admin Dashboard',
    '/client-job-management': 'Opdrachten Beheer',
    '/contractor-job-browser': 'Opdrachten Zoeken',
    '/contractor-dashboard': 'Dashboard',
    '/affiliate-dashboard': 'Affiliate Dashboard',
    '/user-profile-management': 'Profiel Beheer',
    '/job-details-and-applications': 'Opdracht Details'
  };

  const generateBreadcrumbs = () => {
    if (customBreadcrumbs) {
      return customBreadcrumbs;
    }

    const pathSegments = location?.pathname?.split('/')?.filter(segment => segment);
    
    if (pathSegments?.length === 0) {
      return [{ label: 'Home', path: '/' }];
    }

    const breadcrumbs = [{ label: 'Home', path: '/' }];
    
    let currentPath = '';
    pathSegments?.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const label = routeLabels?.[currentPath] || segment?.charAt(0)?.toUpperCase() + segment?.slice(1)?.replace(/-/g, ' ');
      breadcrumbs?.push({
        label,
        path: currentPath,
        isLast: index === pathSegments?.length - 1
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs?.length <= 1) {
    return null;
  }

  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex items-center gap-2 flex-wrap">
        {breadcrumbs?.map((crumb, index) => (
          <li key={crumb?.path} className="flex items-center gap-2">
            {index > 0 && (
              <Icon 
                name="ChevronRight" 
                size={16} 
                className="text-muted-foreground flex-shrink-0"
              />
            )}
            {crumb?.isLast ? (
              <span className="caption text-foreground font-medium">
                {crumb?.label}
              </span>
            ) : (
              <Link
                to={crumb?.path}
                className="caption text-muted-foreground hover:text-foreground transition-smooth"
              >
                {crumb?.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default BreadcrumbNavigation;